<template>
  <div class="gallery">
    <div v-if="sizeMdMax" class="gallery__slider">
      <div ref="swiper" class="gallery__slider-swiper swiper">
        <div class="swiper-wrapper">
          <div
            v-for="({ id, path, url }, index) in getPreviewGallery"
            :key="id"
            class="gallery__slider-slide swiper-slide"
          >
            <div
              v-lazy:background-image="path || url"
              class="gallery__card u-bg-cover u-clickable"
              @click="showPopupSlider(index)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <gallery-cropped v-else :gallery="getPreviewGallery" :crop-by="cropBy">
      <template #default="{ itemsVisible, itemsInModal, hasModal }">
        <div class="gallery__cards" ref="gallery__cards">
          <div
            v-for="({ id, path, url }, index) in itemsVisible"
            :key="id"
            v-lazy:background-image="path || url"
            class="gallery__card u-bg-cover u-clickable"
            :class="{ _counter: hasModal && index === cropBy - 1 }"
            @click="showPopupSlider(index)"
          >
            <more-photos-counter
              v-if="hasModal && index === cropBy - 1"
              :count="itemsInModal.length - 1"
            />
          </div>
        </div>
      </template>
    </gallery-cropped>
    <popup-photo-slider
      v-model="popups.slider"
      :photos="getPopupGallery"
      :initial-slide="initialSlide"
    />
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/swiper.scss";
import { sizeMdMax } from "@/assets/js/utils/mq";
import {getImageCdnUrl} from "@/assets/js/utils/get-img-cdn";
import GalleryCropped from "@/components/renderless/gallery-cropped/index.vue";
import MorePhotosCounter from "@/components/molecules/more-photos-counter/index.vue";
import PopupPhotoSlider from "@/components/molecules/popup-photo-slider/index.vue";

export default {
  components: {
    GalleryCropped,
    MorePhotosCounter,
    PopupPhotoSlider,
  },
  props: {
    gallery: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      swiperInstance: null,
      cropBy: 3,
      popups: {
        slider: false,
      },
      initialSlide: 0,
    };
  },
  computed: {
    sizeMdMax,
    getPreviewGallery(){
      return this.gallery.map((item) => ({
        id: item.id,
        path: getImageCdnUrl(item.path || item.url, 236, 168)
      }))
    },
    getPopupGallery() {
      return this.gallery.map((item) => ({
        id: item.id,
        path: getImageCdnUrl(item.path || item.url, 750)
      }))
    }
  },
  watch: {
    sizeMdMax: {
      immediate: true,
      handler(sizeMdMax) {
        if (sizeMdMax) {
          setTimeout(this.initSlider);
          return;
        }

        this.destroySlider();
      },
    },
  },
  beforeDestroy() {
    this.destroySlider();
  },

  methods: {
    initSlider() {
      this.swiperInstance = new Swiper(this.$refs.swiper, {
        touchReleaseOnEdges: true,
        observer: true,
        slidesPerView: "auto",
      });
    },
    destroySlider() {
      this.swiperInstance?.destroy();
    },
    showPopupSlider(index) {
      this.initialSlide = index;
      this.popups.slider = true;
    },
  },
};
</script>

<style lang="scss" scoped>
$b: ".gallery";

#{$b} {
  &__cards {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-gap: 0 8px;
  }

  &__card {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    width: 224px;
    height: 152px;
    margin: 0 4px;
    background-color: var.$gray-light;

    @include mixin.size-sm-min {
      width: 229px;
    }

    @include mixin.size-lg-min {
      @include mixin.aspect-ratio(236, 168);
      width: auto;
      height: auto;
      margin: 0;
    }

    &:not(._counter) {
      &:hover {
        &::before {
          background: rgba(var.$pitch-black, 0.2);
        }
      }

      &::before {
        @include mixin.decor();
        @include mixin.full-pos(0);
        content: "";
        display: block;
        position: absolute;
        background: rgba(var.$pitch-black, 0);
        transition: var.$transition-slow;
      }
    }
  }

  &__slider {
    margin: 0 -4px;

    &-swiper {
      overflow: visible;
    }

    &-slide {
      display: flex;
      width: auto;
      height: auto;
    }
  }
}
</style>
